module.exports = __webpack_public_path__ + "img/Network.b9db7fef.png";